import apiClient from '@/services/api-client';
import { apiSuccessCheck, noData } from './utilities';

export default async function apiClientGet(endpoint) {
	try {
		const { status, data } = await apiClient().get(endpoint);

		if (!apiSuccessCheck(status)) {
			throw new Error('API call failed');
		}

		if (noData(data)) {
			throw new Error('No data received');
		} else {
			return Promise.resolve(data);
		}
	} catch (error) {
		return Promise.reject(error);
	}
}
